import { GlobalAppState } from '@model/state';

export const getTourAvailability = (state: GlobalAppState) => {
  return state.tours.tourAvailability.data;
};
export const getTourAvailabilityLoading = (state: GlobalAppState) => {
  return state.tours.tourAvailability.loading;
};
